import PrintGeneralReport from "./PrintGeneralReports";

// تستقبل payload من GeneralReportsTap (meta, data, keys) ثم تمرّرها لـ PrintGeneralReport
export const printGeneralReportUtils = async (payload = {}, options = {}) => {
  const printWindow = window.open("", "printWindow", "width=900,height=700");
  if (!printWindow) {
    alert("⚠️ المتصفح منع نافذة الطباعة. اسمح بالنوافذ المنبثقة.");
    return;
  }

  try {
    // PrintGeneralReport متوقع أن يُرجع HTML جاهز للطباعة عند تمرير payload
    // payload قد يحتوي: { meta: {from,to,...}, data: { key: [...] }, keys: [...] }
    const html = await PrintGeneralReport(payload, options);

    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();

    const tryClose = () => {
      try {
        if (printWindow && !printWindow.closed) printWindow.close();
      } catch (e) {
        /* ignore */
      }
    };

    printWindow.onafterprint = tryClose;
    try {
      printWindow.addEventListener && printWindow.addEventListener("afterprint", tryClose);
    } catch (e) {
      /* ignore */
    }

    const fallbackTimer = setTimeout(() => {
      tryClose();
    }, 12000);

    const clearIfClosed = () => {
      if (!printWindow || printWindow.closed) {
        clearTimeout(fallbackTimer);
        try {
          printWindow.onafterprint = null;
          printWindow.removeEventListener && printWindow.removeEventListener("afterprint", tryClose);
        } catch (e) {}
      }
    };

    printWindow.print();
    const pollInterval = setInterval(() => {
      if (!printWindow || printWindow.closed) {
        clearInterval(pollInterval);
        clearIfClosed();
      }
    }, 500);
  } catch (err) {
    console.error("❌ خطأ أثناء تجهيز أو طباعة تقرير اليومية:", err);
    alert("فشل في تجهيز تقرير الطباعة.");
    try {
      if (!printWindow.closed) printWindow.close();
    } catch (e) {}
  }
};
